import React from 'react';

type TypeProps = {
  color: string;
};

const Icon = ({ color }: TypeProps) => {
  return (
    <svg
      id="Pointers"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 179.74 175.66"
      width={30}
      height={30}
      style={{
        top: '-8px',
        left: '-8px',
      }}
    >
      <g clipPath="url(#clip0_1_2)">
        <g opacity="0.7">
          <path
            d="M73.4777 66.6597L88.1088 80.8931L92.2951 76.8952L77.8315 62.306L85.8691 54.373L127.523 95.6289L92.2114 130.647L85.9947 130.919L60.0816 109.779L68.7054 100.82L53.5091 85.9376L73.4777 66.6597Z"
            fill="#8C50B4"
          />
        </g>
        <path
          d="M85.2831 133.033L57.0047 109.967L65.754 100.883L50.495 85.9167L73.4777 63.7503L88.1297 77.9837L89.3228 76.8534L74.8801 62.2851L85.8691 51.4216L130.495 95.6289L93.1324 132.698L85.304 133.054L85.2831 133.033ZM63.1795 109.59L86.7064 128.784L91.3323 128.575L124.55 95.608L85.8482 57.3034L80.7828 62.306L95.2674 76.9371L88.0879 83.8026L73.4568 69.5902L56.5023 85.9585L71.6567 100.799L63.1795 109.611V109.59Z"
          fill="#8C50B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect
            width="80"
            height="81.6117"
            fill="white"
            transform="translate(50.495 51.4216)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
